import moment from "moment";

export function getWeekNumberYear() {
	const currentDate = moment();
	const weeks = [];

	for (let i = 0; i < 13; i++) {
		weeks.push(`${currentDate.format('WW')}-${currentDate.format('YYYY')}`);
		currentDate.subtract(1, 'week');
	}

	return weeks;
}

export function capitalizeWords(sentence) {
	return sentence.split(" ").map(word => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()).join(" ");
}

export function createFullName(firstName, infix, lastname) {
	return [firstName, infix, lastname].filter(v => v != null && v.trim() !== "").join(" ");
}

export function formatInitials(initials) {
	if(initials == null || initials.trim().length === 0) return;
	return initials
		.toUpperCase()
		.replaceAll(".", "")
		.split("")
		.join(".") + ".";
}

export function formatPrice(price) {
	if(price == null) return price;
	return parseFloat(price).toFixed(2);
}

export function formatHexColor(color) {
	if(color == null || color.trim() === "") return color;
	if(color.startsWith("#")) return color;
	return "#" + color;
}
